import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { ListBuilderComponentModule } from '@adaptiva/widgets/list-builder';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { RealTimePropertiesComponent } from './real-time-properties.component';

const widgets = [
	CardComponentModule,
	ContainerComponentModule,
	TextComponentModule,
	ListBuilderComponentModule,
	AuthoringPropertyLabelComponentModule
];

const pipes = [
	InheritPipe,
	DisplayAuthoringPropertyPipe,
	IsRequiredPropertyPipe,
];

@NgModule({
	imports: [
		CommonModule,
		...widgets,
		...pipes
	],
	declarations: [RealTimePropertiesComponent],
	exports: [RealTimePropertiesComponent]
})
export class RealTimePropertiesComponentModule {

}
